import { dataTv } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTv = /*#__PURE__*/createIcon(dataTv)
export default IconTv
